import { ShieldCheck, Truck, CreditCard, RefreshCw } from "lucide-react";

export const TrustBadges = () => {
    const badges = [
        { icon: ShieldCheck, text: "Secure Payment" },
        { icon: Truck, text: "Fast Shipping" },
        { icon: CreditCard, text: "All Cards Accepted" },
        { icon: RefreshCw, text: "30-Day Returns" },
    ];

    return (
        <div className="py-8 bg-gray-50 border-y">
            <div className="container mx-auto flex flex-wrap justify-center gap-8">
                {badges.map((badge, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-gray-600">
                        <badge.icon className="w-5 h-5" />
                        <span className="font-medium">{badge.text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
